//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import { AXIOS } from '../../../../axios/axios.js'
import UserInfoReadonlyInputItem from './UserInfoReadonlyInputItem.vue'

export default {
  components: {
    UserInfoReadonlyInputItem
  },
  data: function () {
    return {
      userInfo: null,
      imgUrl: null,
      translatedRoles: [],
      loaded: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    phones: function () {
      const phones = []

      const userInfo = this.userInfo
      if (userInfo.phone) {
        phones.push(userInfo.phone)
      }
      if (userInfo.phone1) {
        phones.push(userInfo.phone1)
      }
      if (userInfo.phone2) {
        phones.push(userInfo.phone2)
      }
      if (userInfo.phone3) {
        phones.push(userInfo.phone3)
      }

      if (phones.length) {
        return phones.join('\n')
      }
      return ''
    }
  },
  watch: {
    user: {
      handler: function (val) {
        if (val) {
          this.load()
        }
      },
      immediate: true
    },
    userInfo: {
      handler: function (val) {
        if (val) {
          this.loaded = true
        }
      },
      immediate: true
    }
  },
  methods: {
    load: function () {
      if (this.user.employee) {
        AXIOS
          .get('/service/obj/properties?id=' + this.user.employee.id + '&change=false')
          .then((response) => {
            this.userInfo = response.data.result
            if (this.userInfo.image) {
              this.imgUrl = '/service/delta/document/thumbnail/' + this.userInfo.image[0].id + '/78/104'
            }
          })
        AXIOS
          .get('/service/sysobj/typetree?id=employee&appendObjects=true')
          .then((response) => {
            const typeId = response.data.typeId
            const smth = response.data.result[typeId]
            let id = null
            let id2 = null
            smth.forEach(element => {
              if (element.key == 'params') {
                id = element.id
              }
            })
            if (id) {
              const smth2 = response.data.result[id]
              smth2.forEach((element) => {
                if (element.key == 'role') {
                  id2 = element.id
                }
              })
              if (id2 && this.loaded) {
                const smth3 = response.data.objects[id2].listvalues
                for (let i = 0; i < this.userInfo.role.length; i++) {
                  for (let j = 0; j < smth3.value.length; j++) {
                    if (this.userInfo.role[i] == smth3.value[j]) {
                      this.translatedRoles.push(smth3.name[j])
                    }
                  }
                }
              }
            }
          })
      }
    }
  }
}

